import type React from 'react';

import { CrossIcon } from '@vlabs/icons';
import { SideMenu } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button';
import { useTranslation } from 'react-i18next';

import { filterIsApplied } from '@vlabs/monokit/shared/ui/filter-menu';

import {
  ReferenceFilterWithLeftPopover,
  SourceFilterWithLeftPopover,
  StatusFilterWithLeftPopover,
} from './side-menu';
import st from './SourceFiltersMenu.module.sass';
import { useSourceFilters } from './useSourceFilters';
import { useGroupStreamsCounts } from '../api/useGroupStreamsCounts';

interface SourceFiltersMenuProps {
  onClose: VoidFunction;
}

// Собственная панель фильтров группы (FilterMenu зарезервирован для фильтров страницы)
export function SourceFiltersMenu({
  onClose,
}: SourceFiltersMenuProps): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, setFilters } = useSourceFilters();
  const groupStreamsCounts = useGroupStreamsCounts(filters.group_id ?? '');
  const isSourceFilterDisabled = !groupStreamsCounts.isLoading && groupStreamsCounts.total === 0;

  const isResetDisabled = [filters.statuses?.length, filters.names?.length, filters.reference]
    .filter(Boolean).length === 0;

  return (
    <div className={st.SourceFiltersMenu}>
      <div className={st.Header}>
        <span className={st.Title}>{t('entities:source_filters.title')}</span>
        <CrossIcon
          className={st.CloseIcon}
          data-testid="close-source-filters"
          onClick={onClose}
        />
      </div>

      <SideMenu.MenuItemDivider />

      <StatusFilterWithLeftPopover
        badge={filterIsApplied((filters.statuses?.length ?? 0) > 0)}
        key="status"
        value={t('entities:source_filters.status.menu_item_title')}
      />
      <SideMenu.MenuItemDivider />
      <SourceFilterWithLeftPopover
        badge={filterIsApplied((filters.names?.length ?? 0) > 0)}
        disabled={isSourceFilterDisabled}
        key="source"
        value={t('entities:source_filters.source.menu_item_title')}
      />
      <SideMenu.MenuItemDivider />
      <ReferenceFilterWithLeftPopover
        badge={filterIsApplied(!!filters.reference)}
        key="reference"
        value={t('entities:source_filters.reference.menu_item_title')}
      />
      <SideMenu.MenuItemDivider />

      <div className={st.Footer}>
        <Button
          data-testid="button.reset-source-filters"
          disabled={isResetDisabled}
          fullWidth
          kind="negative"
          onClick={() => setFilters({
            group_id: filters.group_id,
            page: 1,
            page_size: filters.page_size,
          })}
        >
          {t('entities:source_filters.reset.label')}
        </Button>
      </div>
    </div>
  );
}
